import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["name", "email", "mobile", "errorMessage", "nameError", "emailError", "mobileError"]
  static values = { demoUrl: String, redirectOnSuccess: { type: Boolean, default: true } }

  connect() {
    this.element.addEventListener("demo-modal:open", this.open.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("demo-modal:open", this.open.bind(this))
  }

  open() {
    if (this.submitted) return
    this.clearError()
    $(this.element).modal("show")
  }

  close() {
    $(this.element).modal("hide")
  }

  snooze() {
    const secs = 60
    const until = Math.floor(Date.now() / 1000) + secs
    document.cookie = `demo_modal_snoozed_until=${until}; path=/; max-age=${secs}`
    this.close()
  }

  submit(e) {
    e?.preventDefault()

    this.clearError()
    this.clearFieldErrors()

    const name = this.nameTarget.value.trim()
    const email = this.emailTarget.value.trim()
    const mobile = this.mobileTarget.value.trim()
    const errors = []
    if (!name) errors.push("Name is required")
    if (!email) errors.push("Email is required")
    if (!mobile) errors.push("Mobile is required")
    if (errors.length) {
      if (!name) this.setFieldError("name", "Name is required")
      if (!email) this.setFieldError("email", "Email is required")
      if (!mobile) this.setFieldError("mobile", "Mobile is required")
      return
    }

    const payload = new URLSearchParams({
      "demo_lead[name]": name,
      "demo_lead[email]": email,
      "demo_lead[mobile]": mobile
    }).toString()

    Rails.ajax({
      type: "POST",
      url: "/demo_leads",
      data: payload,
      dataType: "json",
      success: data => {
        if (data.ok) {
          if (this.redirectOnSuccessValue) {
            window.location.href = this.demoUrlValue
          } else {
            this.submitted = true
            this.showSuccess("Thank you! We've recorded your interest.")
            window.setTimeout(() => this.close(), 2000)
          }
        } else {
          this.renderFieldErrors(data.field_errors)
          if (!data.field_errors) this.showError(data.errors || ["An error occurred"])
        }
      },
      error: response => {
        const errorData = this.parseErrorResponse(response)
        this.renderFieldErrors(errorData?.field_errors)
        if (!errorData?.field_errors) {
          this.showError(errorData?.errors || ["Network error. Please try again."])
        }
      }
    })
  }

  parseErrorResponse(response) {
    if (response?.ok === false) return response
    if (response?.responseJSON) return response.responseJSON
    if (response?.responseText) {
      try {
        return JSON.parse(response.responseText)
      } catch (error) {
        return null
      }
    }
    return null
  }

  setMessage(content, type = "error") {
    if (!this.hasErrorMessageTarget) return
    const el = this.errorMessageTarget
    el.textContent = Array.isArray(content) ? content.join(", ") : content
    el.classList.remove("hidden", "text-danger", "text-success")
    if (type === "success") el.classList.add("text-success")
    else if (type === "error") el.classList.add("text-danger")
    if (type === "clear") el.classList.add("hidden")
    else el.classList.remove("hidden")
  }

  showError(errors) {
    this.setMessage(errors, "error")
  }

  clearError() {
    this.setMessage("", "clear")
  }

  clearFieldErrors() {
    this.setFieldError("name", "", true)
    this.setFieldError("email", "", true)
    this.setFieldError("mobile", "", true)
  }

  renderFieldErrors(fieldErrors) {
    if (!fieldErrors) return
    Object.entries(fieldErrors).forEach(([field, messages]) => {
      this.setFieldError(field, messages)
    })
  }

  setFieldError(field, messages, clear = false) {
    const targetMap = {
      name: "nameError",
      email: "emailError",
      mobile: "mobileError"
    }
    const targetName = targetMap[field]
    if (!targetName) return

    const targetKey = `${targetName}Target`
    if (!this[targetKey]) return

    const el = this[targetKey]
    if (clear) {
      el.textContent = ""
      el.classList.add("d-none")
      return
    }

    const content = Array.isArray(messages) ? messages.join(", ") : messages
    el.textContent = content
    if (content) el.classList.remove("d-none")
  }

  showSuccess(message) {
    this.setMessage(message, "success")
  }
}
